import React from "react"
import { AppBasicTable } from "@components"
import { dsColorNew } from "@palette"
import ReportFormDrawerCsvTableActions from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Csv/Table/Actions"
import { dateColumn, timeColumn } from "./@columns"
import ReportFormDrawerCsvFileName from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Csv/Table/FileName"

const tableHeaders = [
	{ label: "Date from & to" },
	{ label: "Time from & to" }
]

export default function ReportFormDrawerCsvTable({ file, onDownload, onDelete, csvData }) {

	if (!csvData.length) return null

	return <AppBasicTable
		sx={{ maxHeight: 300, borderRadius: 1 }}
		cardProps={{ sx: { border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '12px', boxShadow: 'none', '&:hover': { boxShadow: 'none' } } }}
		data={csvData}
		columns={[dateColumn(), timeColumn()]}
		toolbarProps={{ actions: false }}
		headers={[tableHeaders]}
		Components={{
			Title: () => <ReportFormDrawerCsvFileName file={file}/>
		}}
		actions={<ReportFormDrawerCsvTableActions onDownload={onDownload} onDelete={onDelete}/>}
	/>
}